module.exports = __webpack_public_path__ + "static/media/lw.bc905c73.png";